import React from "react";
import PropTypes from "prop-types";

import NoScoreAvailableImage from "./NoScoreAvailableImage";
import EmptyStateTemplate from "shared/react_components/EmptyStates/EmptyStateTemplate";

const NoScoreAvailable = ({ height, width, headerFontSize, messageFontSize, message }) => (
  <EmptyStateTemplate
    width={width}
    height={height}
    headerFontSize={headerFontSize}
    messageFontSize={messageFontSize}
    headerMessage="No Score Available!"
    message={message}
    emptyStateImage={NoScoreAvailableImage}
  />
);

NoScoreAvailable.propTypes = {
  /**
   * The width of the image graphic
   */
  width: PropTypes.string,
  /**
   * The height of the image graphic
   */
  height: PropTypes.string,
  /**
   * The font size of the header message
   */
  headerFontSize: PropTypes.string,
  /**
   * The font size of the header message
   */
  messageFontSize: PropTypes.string,
  /**
   * A message that explains why the space is empty or what action is needed to populate the space
   */
  message: PropTypes.string.isRequired
};

NoScoreAvailable.defaultProps = {
  width: "320px",
  height: "220px",
  headerFontSize: "14px",
  messageFontSize: "14px"
};

export default NoScoreAvailable;
